import { Box, Flex, Spinner } from "@radix-ui/themes";
import React from "react";
import { LoaderProps } from "./Loader.types";

/**
 * Loader component that displays a centered spinner in the color of the current theme.
 *
 * This component uses Flexbox to center a Spinner component both
 * horizontally and vertically within its container.
 *
 * @returns {JSX.Element} The rendered Loader component.
 */

const Loader: React.FC<LoaderProps> = ({ children }) => {
  return (
    <Flex align="center" justify="center" className="loader">
      <Flex align="center" gap="2" direction="column">
        <Spinner />
        {children && <Box as="span">{children}</Box>}
      </Flex>
    </Flex>
  );
};

export default Loader;
